import { __decorate, __metadata } from "tslib";
import { Component, Ref } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvFloatingSlideCard";
/**
 * A card floating at the bottom of the screen.
 * <br>Can be expanded by click or swap gesture.
 */
let LvFloatingSlideCard = class LvFloatingSlideCard extends UIComponent {
    constructor() {
        super(...arguments);
        this.status = "minimized";
    }
    get classList() {
        return [
            this.status,
        ].filter(x => x != null);
    }
    beforeDestroy() {
        document.body.classList.remove("lv-touch-freeze");
    }
    onTouchStart(ev) {
        document.body.classList.add("lv-touch-freeze");
    }
    onTouchEnd(ev) {
        document.body.classList.remove("lv-touch-freeze");
    }
    onTouchCancel(ev) {
        document.body.classList.remove("lv-touch-freeze");
    }
    /**
     * Maximize the card
     */
    maximize() {
        this.status = "maximized";
        requestAnimationFrame(() => {
            this.content.style.maxHeight = (window.innerHeight - this.header.offsetHeight - 25) + "px";
        });
    }
    /**
     * Minimize the card
     */
    minimize() {
        this.status = "minimized";
        requestAnimationFrame(() => {
            this.content.style.maxHeight = "0px";
        });
    }
    /**
     * Maximize or minimize the card
     */
    toggle() {
        if (this.status == "maximized") {
            this.minimize();
        }
        else if (this.status == "minimized") {
            this.maximize();
        }
    }
    /**
     * Completely hide the card
     */
    hide() {
        this.status = "hidden";
    }
};
__decorate([
    Ref(),
    __metadata("design:type", HTMLDivElement)
], LvFloatingSlideCard.prototype, "card", void 0);
__decorate([
    Ref(),
    __metadata("design:type", HTMLDivElement)
], LvFloatingSlideCard.prototype, "header", void 0);
__decorate([
    Ref(),
    __metadata("design:type", HTMLDivElement)
], LvFloatingSlideCard.prototype, "content", void 0);
LvFloatingSlideCard = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvFloatingSlideCard);
export default LvFloatingSlideCard;
//# sourceMappingURL=script.js.map